import { Component, OnInit, ViewChild } from '@angular/core';
import { DayBookSalesComponent } from './day-book-sales/day-book-sales.component';
import { NgbDateStruct, NgbOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import {
  faIndianRupeeSign,
  faWrench,
  faCube,
  faArrowTrendUp,
  faArrowTrendDown,
  faCalendar,
  faBuilding,
  faDownload,
  faEye,
  faRotate,
  faReceipt,
  faBuildingColumns,
} from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookExpensesComponent } from './day-book-expenses/day-book-expenses.component';
import { Router } from '@angular/router';
import { first } from 'rxjs';

@Component({
  selector: 'app-day-book',
  templateUrl: './day-book.component.html',
  styleUrls: ['./day-book.component.scss'],
  standalone: false
})
export class DayBookComponent implements OnInit {

  @ViewChild(DayBookSalesComponent) salesComponent!: DayBookSalesComponent;
  @ViewChild(DayBookExpensesComponent) expensesComponent!: DayBookExpensesComponent;

  protected readonly faArrowTrendUp = faArrowTrendUp;
  protected readonly faArrowTrendDown = faArrowTrendDown;
  protected readonly faCalendar = faCalendar;
  protected readonly faBuilding = faBuilding;
  protected readonly faDownload = faDownload;
  protected readonly faRotate = faRotate;
  protected readonly faEye = faEye;
  protected readonly faReceipt = faReceipt;
  protected readonly faBuildingColumns = faBuildingColumns;

  selectedVoucher: { url: any; name: any } = { url: '', name: '' };

  currentDate: any;
  ngbMaxDate!: NgbDateStruct;
  currentNgbDate!: NgbDateStruct;
  selectedBranchId: string = '';
  branches: any[] = [{ _id: '', name: 'All Branches' }];
  isBranchVisible: boolean = false;
  totalInvoices: number = 0;
  loader: boolean = false;
  errMsg: string = '';
  listLoader: boolean = false;
  listErrMsg: string = '';
  exportList: any[] = [];
  exportPage: number = 0;
  endOfExportResults: boolean = false;

  hasReturnsFromCustomer = false;
  hasReturnsToDealer = false;

  summaryCards: any[] = [
    {
      title: 'Total Sales',
      icon: faIndianRupeeSign,
      value: 0,
      useKFormat: false,
      footerValue: 0,
      isNegative: false,
      footerLabel: '',
      hidePercentage: false
    },
    {
      title: 'Services',
      icon: faWrench,
      value: 0,
      useKFormat: true,
      footerValue: 0,
      isNegative: false,
      footerLabel: '',
      hidePercentage: false
    },
    {
      title: 'Tyre Sales',
      icon: faCube,
      value: 0,
      useKFormat: true,
      footerValue: 0,
      isNegative: false,
      footerLabel: '',
      hidePercentage: false
    },
    {
      title: 'Unsettled',
      icon: faBuildingColumns,
      value: 0,
      useKFormat: true,
      footerValue: 0, 
      isNegative: false, 
      footerLabel: '',
      hidePercentage: false
    },
    {
      title: 'Expenses',
      icon: faReceipt,
      value: 0,
      useKFormat: true,
      footerValue: 0,
      isNegative: false,
      footerLabel: '',
      hidePercentage: false
    },
  ];

  constructor(
    private readonly companyService: CompanyServiceService,
    private readonly storageService: StorageService,
    private readonly dayBookService: DayBookService,
    private readonly cmnService: CommonServiceService,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly router: Router
  ) {
    const today = new Date();
    this.ngbMaxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
  }

  ngOnInit(): void {
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
    if (this.isBranchVisible) {
      this.getBranchList();
    }

    this.dayBookService.getSavedDayBookDate().pipe(first()).subscribe((savedState: any) => {
      if (savedState?.currentDate) {
        this.setPreSelectedDate(savedState);
      } else {
        this.setDefaultDate();
      }
      this.getCardsValues();
    });
  }

  setPreSelectedDate(savedState: any) {
    this.currentDate = savedState.currentDate;
    const [year, month, day] = this.currentDate.split('-').map(Number);
    this.currentNgbDate = { year, month, day };
    if (savedState.selectedBranchId) {
      this.selectedBranchId = savedState.selectedBranchId;
    }
    this.dayBookService.clearSavedDayBookDate();
  }

  setDefaultDate() {
    const defaultDate = new Date();
    if (defaultDate.getHours() < 12) {
      defaultDate.setDate(defaultDate.getDate() - 1);
    }
    this.currentDate = this.cmnService.formatDate(defaultDate);
    this.currentNgbDate = {
      year: defaultDate.getFullYear(),
      month: defaultDate.getMonth() + 1,
      day: defaultDate.getDate()
    };
  }

  getBranchList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      let branchList = res.data || [];
      branchList = branchList?.filter((company: any) => company.status === 'Active') || [];
      this.branches = [...this.branches, ...branchList]
    });
  }

  get selectedBranch(): string {
    if (!this.selectedBranchId) {
      return 'All Branches';
    }
    const matchedBranch = (this.branches || []).find(b => b._id === this.selectedBranchId);
    return matchedBranch ? matchedBranch.name : 'All Branches';
  }

  onSelectBranch(branch: any) {
    this.selectedBranchId = branch._id;
    this.getCardsValues();
  }


  getCardsValues() {
    let params: any = {
      created_date: this.currentDate
    }
    if (this.selectedBranchId) {
      params.company = this.selectedBranchId
    }
    this.dayBookService.getHighlights(params).subscribe({
      next: (res: any) => {
        this.mapResponse(res.data || {})
      }
    })
  }

  mapResponse(data: any) {
    this.summaryCards[0].value = this.cmnService.parseNumberOrZero(data.totalSales)
    this.summaryCards[0].footerValue = this.cmnService.parseNumberOrZero(data.totalSalesChange)
    this.summaryCards[0].isNegative = this.summaryCards[0].footerValue < 0;
    let invoices = data.invoiceCount ? this.cmnService.parseNumberOrZero(data.invoiceCount) : 0;
    this.totalInvoices = invoices;
    this.summaryCards[0].footerLabel = `${invoices} invoices`

    this.summaryCards[1].value = this.cmnService.parseNumberOrZero(data.serviceAmount);
    this.summaryCards[1].footerValue = this.cmnService.parseNumberOrZero(data.serviceAmountChange);
    this.summaryCards[1].isNegative = this.summaryCards[1].footerValue < 0;
    let jobs = this.cmnService.parseNumberOrZero(data.jobsCount);
    this.summaryCards[1].footerLabel = `${jobs} jobs`

    this.summaryCards[2].value = this.cmnService.parseNumberOrZero(data.salesByTyresAmount);
    this.summaryCards[2].footerValue = this.cmnService.parseNumberOrZero(data.salesByTyresAmountChange);
    this.summaryCards[2].isNegative = this.summaryCards[2].footerValue < 0;
    this.summaryCards[2].footerLabel = `${data.unitsSold} units`;

    this.summaryCards[3].value = this.cmnService.parseNumberOrZero(data.unsettledAmount);
    this.summaryCards[3].footerValue = this.cmnService.parseNumberOrZero(data.unsettledAmountChange);
    this.summaryCards[3].isNegative = this.summaryCards[3].footerValue < 0;

    this.summaryCards[4].value = this.cmnService.parseNumberOrZero(data.totalExpense);
    this.summaryCards[4].footerValue = this.cmnService.parseNumberOrZero(data.totalExpenseChange);
    this.summaryCards[4].isNegative = this.summaryCards[4].footerValue < 0;
    this.summaryCards[4].footerLabel = `${data.expenseCount || 0} entries`;
  }

  onDateSelect(date: NgbDateStruct) {
    if (date) {
      this.currentDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
      this.currentNgbDate = date;
      this.getCardsValues();
    }
  }

  onCardClick(title: string) {
    if (!this.salesComponent) return;
    if (title === 'Total Sales') {
      this.salesComponent.openSalesModalDirectly('full');
    } else if (title === 'Tyre Sales') {
      this.salesComponent.openSalesModalDirectly('tyres');
    } else if (title === 'Services') {
      this.salesComponent.openSalesModalDirectly('services');
    } else if (title ==='Expenses') {
      this.expensesComponent.viewAllExpenses();
    } else if (title === 'Unsettled' && this.isBranchVisible) {
      this.dayBookService.setSavedDayBookDate({
        currentDate: this.currentDate,
        selectedBranchId: this.selectedBranchId,
      });
      this.router.navigate(['/settlements']);
    }
  }

  exportDayBook() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.currentDate
    }
    if (this.selectedBranchId) params.company = this.selectedBranchId
    this.dayBookService.exportDayBook(params).subscribe({
      next:(res: any) => {
        this.loader = false;
        this.refreshExportList();
      },
      error:(err:any) => {
        this.loader = false;
        this.errMsg = err?.error?.error?.message || 'Something went wrong';
      },
    })
  }

  getExportList() {
    this.listLoader = true;
    this.listErrMsg = '';
    this.dayBookService.getExportList({ page: this.exportPage }).subscribe({
      next: (res: any) => {
        this.listLoader = false;
        const listData = res.data || [];
        if (this.exportPage === 0) {
          this.exportList = listData;
        } else {
          this.exportList = [...this.exportList, ...listData];
        }
        if (listData.length === 0) {
          this.endOfExportResults = true;
        }
      },
      error: (err: any) => {
        this.listLoader = false;
        this.listErrMsg = err?.error?.error?.message || err?.error?.message || 'Something went wrong while fetching export list';
      },
    })
  }

  openExportListSidebar(content: any) {
    this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'category-offcanvas'
    });
    this.refreshExportList();
  }

  onScrollExportList() {
    if (this.endOfExportResults || this.listLoader) return;
    this.exportPage++;
    this.getExportList();
  }

  refreshExportList() {
    this.exportList = [];
    this.exportPage = 0;
    this.endOfExportResults = false;
    this.getExportList();
  }

  viewPdf(item: any, pdfModal: any) {
    const url = item.fileUrl;
    if (url) {
      this.selectedVoucher.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.selectedVoucher.name = item.fileName || 'Day Book Export';
      this.modalService.open(pdfModal, {
        size: 'lg',
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'pdf-modal-window',
        backdropClass: 'pdf-modal-backdrop'
      });
    }
  }

  closeToster() {
    this.errMsg = '';
  }

}
